export function canShowUploadToolbarButton({
    canUpload,
    errorPage = false,
    pageVisible = true,
} = {}) {
    return Boolean(pageVisible) && Boolean(canUpload) && !errorPage;
}
